function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useCallback, useContext, useMemo, useEffect } from 'react';
import { StyledReactSelect } from '../../common/StyledReactSelect.styled';
import { Box } from '@tapresearch/ui/components';
import { filterContext } from '../FilterProvider';
export function FilterMultipleSelector(_param) {
    var options = _param.options, _param_onChange = _param.onChange, onChange = _param_onChange === void 0 ? function() {
    //
    } : _param_onChange, name = _param.name, _param_isDisabled = _param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, rest = _object_without_properties(_param, [
        "options",
        "onChange",
        "name",
        "isDisabled"
    ]);
    var context = useContext(filterContext);
    var defaultValues = context.getDefaultValueByName(name) || [];
    var values = context.filterValues[name];
    var optionsByValue = useMemo(function() {
        return options.reduce(function(acc, option) {
            acc[option.value] = option;
            return acc;
        }, {});
    }, [
        options
    ]);
    var selectedOptions = useMemo(function() {
        if (values) {
            return values.map(function(optionValue) {
                return optionsByValue[optionValue];
            });
        }
        return [];
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        optionsByValue,
        defaultValues.join(','),
        values
    ]);
    var defaultSelectedOptions = useMemo(function() {
        return (defaultValues || []).map(function(optionValue) {
            return optionsByValue[optionValue];
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        optionsByValue,
        defaultValues.join(',')
    ]);
    // Update the labels from the default values on the context so they can be shown elsewhere
    useEffect(function() {
        var labels = selectedOptions.map(function(option) {
            return option.label;
        });
        context.onFilterItemLabelChange(name, labels);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultValues.join(',')
    ]);
    var innerOnChange = useCallback(function(options) {
        var values = options.map(function(option) {
            return option.value;
        });
        var labels = options.map(function(option) {
            return option.label;
        });
        onChange(name, values);
        context.onFilterItemChange(name, values, labels);
    }, [
        onChange,
        name,
        context
    ]);
    return /*#__PURE__*/ React.createElement(Box, _object_spread_props(_object_spread({}, rest), {
        margin: "0",
        "data-testid": rest['data-testid'] || "".concat(name ? name + '-' : '', "filter-multiple-select-wrapper")
    }), /*#__PURE__*/ React.createElement(StyledReactSelect, {
        isMulti: true,
        getOptionLabel: function(option) {
            return option.label;
        },
        getOptionValue: function(option) {
            return option.value;
        },
        name: "qualification_answers",
        defaultValue: defaultSelectedOptions,
        closeMenuOnSelect: false,
        options: options,
        value: selectedOptions,
        onChange: innerOnChange,
        className: "basic-multi-select",
        classNamePrefix: "select",
        placeholder: "Click to see options",
        isClearable: true,
        isDisabled: isDisabled
    }));
}
